<button (click)="changeViewMode('default')"
        [class.active]="'default' === applicationStateService.currentViewMode.slug || 'mobile-default' === applicationStateService.currentViewMode.slug"
        [class.firefox]="isFirefox"
        [class.safari]="isSafari"
        class="view-mode-toggle-button"
        data-bs-placement="bottom" data-bs-toggle="tooltip" title="Doppelseiten anzeigen (Blättern)">
    @if ('default' !== applicationStateService.currentViewMode.slug && 'mobile-default' !== applicationStateService.currentViewMode.slug) {
        <img alt="Doppelseiten anzeigen (Blättern)" src="{{ assetService.getUrl('icon-view-flip-inactive.png')}}">
    }
    @if ('default' === applicationStateService.currentViewMode.slug || 'mobile-default' === applicationStateService.currentViewMode.slug) {
        <img
                alt="Als Doppelseiten angezeigt" src="{{ assetService.getUrl('icon-view-flip-active.png')}}">
    }
</button>


<button
        (click)="changeViewMode('scroll')"
        [class.active]="'scroll' === applicationStateService.currentViewMode.slug"
        [class.firefox]="isFirefox"
        [class.safari]="isSafari"
        class="view-mode-toggle-button"
        data-bs-placement="bottom" data-bs-toggle="tooltip" title="Einzelseiten anzeigen (Scrollen)">
    @if ('scroll' !== applicationStateService.currentViewMode.slug) {
        <img
                alt="Einzelseiten anzeigen (Scrollen)" src="{{ assetService.getUrl('icon-view-scroll-inactive.png')}}">
    }
    @if ('scroll' === applicationStateService.currentViewMode.slug) {
        <img
                alt="Als Einzelseiten angezeigt" src="{{ assetService.getUrl('icon-view-scroll-active.png')}}">
    }

</button>